import { StateCreator } from "zustand";
import { config } from "../lib/config";
import { SearchResults, SearchUseplace } from "../types/SearchTypes";
import { AddressSlice } from "./addressStrore";
import { SearchSlice } from "./searchStore";

type ResultsState = {
  results: SearchUseplace[] | undefined | null;
};

type ResultsActions = {
  search: (searchString: string) => void;
  resetResults: () => void;
  // setResults: (results: SearchResult[]) => void;
};

export type ResultsSlice = ResultsState & ResultsActions;

const initialState: ResultsState = {
  results: undefined,
};

export const createResultsSlice: StateCreator<
  SearchSlice & ResultsSlice & AddressSlice,
  [],
  [],
  ResultsSlice
> = (set) => ({
  // initial state
  ...initialState,
  // actions
  search: async (searchString: string) => {
    const term = encodeURIComponent(searchString);
    const res = await fetch(`${config.API_URL}/search?q=${term}`);
    const data = (await res.json()) as SearchResults;
    const results = data.results.useplace;
    set({ results });
  },
  resetResults: () => set(initialState),
});
